
    import Component from "vue-class-component"
    import Vue from 'vue';
    import PopoverInfo from '@/components/PopoverInfo.vue';

    @Component({
    components: {
        PopoverInfo
    }
})
    export default class AdditionalInfoButton extends Vue {
    }
